module.exports = __webpack_public_path__ + "static/media/edit.8e74b5d5.svg";